// extracted by mini-css-extract-plugin
export default {"datapassingblog":"e991f550919861cc18d6"};